import React from 'react';
import { useWorkplaceMedicalProcedureQuery } from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';
import DataTable from '../../../../../../Components/Base/DataTable';
import styles from './ManagerInsuranceCompaniesCaseType.module.scss';

interface Props {
	caseTypeId: string;
}

const ManagerInsuranceCompaniesCaseType = ({ caseTypeId }: Props) => {
	const { data, isLoading } = useWorkplaceMedicalProcedureQuery({
		where: { id: caseTypeId },
	});

	if (isLoading) {
		return <Loading />;
	}

	const tableData = [
		{
			key: 'code',
			label: 'component.caseType.tableCode',
			value: data?.workplaceMedicalProcedure?.medicalProcedure.code,
		},
		{
			key: 'name',
			label: 'component.caseType.tableName',
			value: data?.workplaceMedicalProcedure?.medicalProcedure.name,
		},
		{
			key: 'description',
			label: 'component.caseType.tableDescription',
			value: data?.workplaceMedicalProcedure?.medicalProcedure.description,
		},
		{
			key: 'points',
			label: 'component.caseType.tablePoints',
			value: data?.workplaceMedicalProcedure?.points,
		},
		{
			key: 'mainFieldOfCare',
			label: 'component.caseType.tableMainFieldOfCare',
			value: data?.workplaceMedicalProcedure?.medicalProcedure.mainFieldOfCare,
		},
		{
			key: 'sharedFieldOfCare',
			label: 'component.caseType.tableSharedFieldOfCare',
			value:
				data?.workplaceMedicalProcedure?.medicalProcedure.sharedFieldOfCare?.join(
					', ',
				),
		},
		{
			key: 'insuranceCompanyCodes',
			label: 'component.caseType.tableInsuranceCompanies',
			value: data?.workplaceMedicalProcedure?.insuranceCompanyCodes?.join(', '),
		},
	];

	return (
		<div className={styles.detailTableWrapper}>
			<DataTable>
				{tableData.map(({ label, key, value }) => (
					<DataTable.Row key={key} label={label} value={value} />
				))}
			</DataTable>
		</div>
	);
};

export default ManagerInsuranceCompaniesCaseType;
